/**
 * AdminKpiGrid — responsive KPI widget grid (BudgetForge-inspired, black-glass).
 * Prefer wrapping AdminStatCard children for consistent rhythm across /admin.
 */
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type AdminKpiGridCols = 2 | 3 | 4 | 5;

const COLS: Record<AdminKpiGridCols, string> = {
  2: "sm:grid-cols-2",
  3: "sm:grid-cols-2 lg:grid-cols-3",
  4: "sm:grid-cols-2 xl:grid-cols-4",
  5: "sm:grid-cols-2 xl:grid-cols-5",
};

export function AdminKpiGrid({
  children,
  cols = 4,
  className,
}: {
  children: ReactNode;
  /** Max columns at xl+. Mobile always 1 col. */
  cols?: AdminKpiGridCols;
  className?: string;
}) {
  return (
    <div className={cn("admin-kpi-grid grid grid-cols-1 gap-3", COLS[cols], className)}>
      {children}
    </div>
  );
}
